// 下記リンクを参考に検索文字列の正規化を行う
// https://spdlybra.nintendo.co.jp/confluence/pages/viewpage.action?pageId=418719245

export function normalizeString(str: string) {
  return str.normalize('NFKC');
}

export function getLowerCaseString(str: string) {
  // ギリシャ文字(\u0370-\u03ff,\u1f00-\u1ffe)のみ小文字化を行わない
  // ギリシャ文字の定義: https://unicode.org/charts/nameslist/c_0370.html, https://unicode.org/charts/nameslist/c_1F00.html
  const strArray = Array.from(str);
  const converted = strArray.map(letter => {
    if (letter.match(/[\u0370-\u03ff]|[\u1f00-\u1ffe]/)) {
      return letter;
    } else {
      return letter.toLocaleLowerCase();
    }
  });
  return converted.join('');
}

export function removeAccent(str: string) {
  // reference: https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .normalize('NFC');
}

export function convertKatakanaToHiragana(str: string) {
  return str.replace(/[\u30a1-\u30f6]/g, match => {
    const katakanaCodePoint = match.codePointAt(0);
    if (katakanaCodePoint) {
      const hiraganaCodePoint = katakanaCodePoint - 0x60;
      return String.fromCodePoint(hiraganaCodePoint);
    } else {
      // カタカナのコードポイントが取得できなかったときはカタカナのまま返す
      return match;
    }
  });
}

// スペースを統一
export function unifySpace(str: string) {
  /*
  U+0020: 半角スペース
  U+0300: 全角スペース
  U+00a0: ノーブレイクスペース
  */
  return str.replace(/\u00a0|\u3000/g, '\u0020');
}

// ハイフンを統一
export function unifyHyphen(str: string) {
  /*
  U+002d: Hyphen-Minus
  U+2010: Hyphen
  U+2011: Non-Breaking Hyphen
  U+2013: En Dash
  U+2014: Em Dash
  U+2027: Hyphenation Point
  */
  return str.replace(/\u2010|\u2011|\u2013|\u2014|\u2027/g, '\u002d');
}

// チルダを統一
export function unifyTilde(str: string) {
  /*
  U+007e: 半角チルダ
  U+ff5e: 全角チルダ
  U+02dc: スモールチルダ
  */
  return str.replace(/\uff5e|\u02dc/g, '\u007e');
}

// 中黒を統一
export function unifyMiddleDot(str: string) {
  /*
  U+00b7: Middle Dot
  U+30fb: Katakana Middle Dot
  */
  return str.replace(/\u30fb/g, '\u00b7');
}

// ダブルクォーテーションを統一
export function unifyDoubleQuotation(str: string) {
  /*
  U+0022: Quotation Mark
  U+201c: Left Double Quotation Mark
  U+201d: Right Double Quotation Mark
  U+201e: Double Low-9 Quotation Mark
  */
  return str.replace(/\u201c|\u201d|\u201e/g, '\u0022');
}

// シングルクォーテーションを統一
export function unifySingleQuotation(str: string) {
  /*
  U+0027: Apostrophe
  U+02bb: Modifier Letter Turned Comma
  U+2018: Left Single Quotation Mark
  U+2019: Right Single Quotation Mark
  U+201a: Single Low-9 Quotation Mark
  U+201b: Single High-Reversed-9 Quotation Mark
  */
  return str.replace(/\u02bb|\u2018|\u2019|\u201a|\u201b/g, '\u0027');
}

// Zero Width Space(U+200B)を削除
export function removeZeroWidthSpace(str: string) {
  return str.replace(/\u200b/g, '');
}

// Word Joiner(U+2060)を削除
export function removeWordJoiner(str: string) {
  return str.replace(/\u2060/g, '');
}

export function normalizeQuery(str: string) {
  let res = str;
  // 不要な文字列を取り除く
  res = removeZeroWidthSpace(res);
  res = removeWordJoiner(res);

  // スペース、ハイフン、チルダ、中黒、ダブルクォーテーション、シングルクォーテーションを統一
  res = unifySpace(res);
  res = unifyHyphen(res);
  res = unifyTilde(res);
  res = unifyMiddleDot(res);
  res = unifyDoubleQuotation(res);
  res = unifySingleQuotation(res);

  // 文字を半角に統一、コードポイントが異なる文字の統一
  res = normalizeString(res);

  // カタカナをひらがなに変換（ひらがなへ統一）
  res = convertKatakanaToHiragana(res);

  // アクセント付き文字のアクセント記号を除去
  res = removeAccent(res);

  // 大文字を小文字に変換（ギリシャ文字を除く）
  res = getLowerCaseString(res);

  return res;
}
